/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { setToken } from "@cw-elements/config";
import axios from "axios";
import { getAccessToken } from "../../lib/auth/accessToken";

export { getAccessToken };

const getAuthorizationHeader = (accessToken = getAccessToken()): string => {
  return accessToken ? `Bearer ${accessToken}` : "Bearer";
};

const UNAUTHORIZED_ERROR_CODE = 401;

const URL = process.env.REACT_APP_API_URL ?? "";

const baseURL = `${URL}`;

export const AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Cache-Control": "no-cache",
    Authorization: getAuthorizationHeader(),
  },
});

AxiosInstance.interceptors.request.use(
  function (config) {
    const orgId = localStorage.getItem("orgId");
    const workspaceId = localStorage.getItem("workspaceId");
    const accessToken = getAccessToken();
    try {
      setToken(accessToken);
    } catch {
      // SDK sync must not prevent an otherwise valid API request.
    }
    config.headers.Authorization = getAuthorizationHeader(accessToken);
    if (orgId) {
      config.headers["org-id"] = orgId;
    }
    if (workspaceId) {
      config.headers["workspace-id"] = workspaceId;
    }
    return config;
  },
  async function (error) {
    return await Promise.reject(new Error(error));
  }
);
AxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      if (error.response.status === UNAUTHORIZED_ERROR_CODE) {
        // Handle unauthorized error
        // authService.getAccessToken();
        // void logout();
      }
    }
    return await Promise.reject(new Error(error));
  }
);

export default AxiosInstance;
